import { render } from "./permission-denied.html?vue&type=template&id=11cce7eb&ts=true"
import script from "./permission-denied.ts?vue&type=script&lang=ts"
export * from "./permission-denied.ts?vue&type=script&lang=ts"

import "./permission-denied.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Vigiflow\\automation-logs-adminlte-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__